var e=(e,t,a,r,l)=>{let d=e=>{e.target&&e.target.matches(a)&&r.call(e.target,e)};return e.addEventListener(t,d,l),d};export{e as default};